export function RightCaret({ size = 'lg' }: { size?: 'sm' | 'lg' }) {
  const dimensions = size === 'sm' ? 24 : 36;
  const viewBoxSize = 24; // Keep the viewBox the same to maintain stroke width

  return (
    <svg width={dimensions} height={dimensions} viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"
      />
    </svg>
  );
}
